
        // 更新加载状态
        function updateLoadingStatus(message) {
            const statusElement = document.getElementById('loading-status');
            if (statusElement) {
                statusElement.textContent = message;
            }
        }

        // 模拟加载过程
        const loadingSteps = [
            { message: '正在初始化渲染引擎...', delay: 500 },
            { message: '正在加载Three.js核心库...', delay: 800 },
            { message: '正在初始化物理引擎...', delay: 600 },
            { message: '正在创建数字控制系统...', delay: 700 },
            { message: '正在构建港口环境...', delay: 900 },
            { message: '正在加载高质量模型...', delay: 1000 },
            { message: '正在启动仿真系统...', delay: 500 },
            { message: '系统就绪，即将启动...', delay: 300 }
        ];

        let currentStep = 0;
        function simulateLoading() {
            if (currentStep < loadingSteps.length) {
                const step = loadingSteps[currentStep];
                updateLoadingStatus(step.message);
                currentStep++;
                setTimeout(simulateLoading, step.delay);
            } else {
                // 加载完成，启动应用
                setTimeout(() => {
                    startApplication();
                }, 500);
            }
        }

        // 启动应用
        async function startApplication() {
            try {
                updateLoadingStatus('正在启动数字化港口应用...');
                
                // 动态导入应用
                const { SimpleDigitalPort } = await import('./src/SimpleDigitalPort.js');
                
                // 创建应用实例
                window.digitalPortApp = new SimpleDigitalPort();
                
                // 初始化应用
                await window.digitalPortApp.init();
                
                // 隐藏加载界面
                setTimeout(() => {
                    const loadingElement = document.getElementById('loading');
                    if (loadingElement) {
                        loadingElement.classList.add('hidden');
                        setTimeout(() => {
                            loadingElement.style.display = 'none';
                        }, 500);
                    }
                }, 1000);
                
                console.log('🎉 数字化港口仿真系统启动成功！');
                
            } catch (error) {
                console.error('❌ 应用启动失败:', error);
                updateLoadingStatus('启动失败，请刷新页面重试');
                
                // 显示错误信息
                setTimeout(() => {
                    const loadingContent = document.querySelector('.loading-content');
                    if (loadingContent) {
                        loadingContent.innerHTML = `
                            <h2 style="color: #ff5252; margin-bottom: 20px;">❌ 启动失败</h2>
                            <p style="margin-bottom: 20px;">系统启动时遇到错误，可能的原因：</p>
                            <ul style="text-align: left; margin-bottom: 30px; line-height: 1.6;">
                                <li>浏览器不支持WebGL 2.0</li>
                                <li>网络连接问题</li>
                                <li>内存不足</li>
                                <li>浏览器版本过旧</li>
                            </ul>
                            <button onclick="location.reload()" style="
                                background: #00ff88;
                                color: black;
                                border: none;
                                padding: 12px 24px;
                                border-radius: 6px;
                                font-size: 16px;
                                font-weight: bold;
                                cursor: pointer;
                            ">重新加载</button>
                        `;
                    }
                }, 1000);
            }
        }

        // 检查浏览器兼容性
        function checkCompatibility() {
            const canvas = document.createElement('canvas');
            const gl = canvas.getContext('webgl2');
            
            if (!gl) {
                updateLoadingStatus('浏览器不支持WebGL 2.0');
                return false;
            }
            
            return true;
        }

        // AI对话功能
        class AIPortAssistant {
            constructor() {
                this.isOpen = false;
                this.isProcessing = false;
                this.conversationHistory = [];
                this.isResizing = false;
                this.resizeData = {};
                this.deepseekApiKey = 'sk-d7208f11e4a3415c8b6c111f26bdb0f3';
                this.portDataContext = this.initializePortDataContext();

                // 动态图表系统（将异步初始化）
                this.chartGenerator = null;
                this.dataSimulator = null;
                this.isInitialized = false;

                // 异步初始化
                this.init().then(() => {
                    this.isInitialized = true;
                    console.log('✅ AI助手初始化完成');
                }).catch(error => {
                    console.error('❌ AI助手初始化失败:', error);
                });
            }

            // 异步初始化动态图表系统
            async initializeChartSystems() {
                try {
                    console.log('🔄 开始初始化动态图表系统...');

                    // 动态导入模块
                    console.log('📦 导入DynamicChartGenerator模块...');
                    const { DynamicChartGenerator } = await import('./src/charts/DynamicChartGenerator.js');
                    console.log('📦 导入PortDataSimulator模块...');
                    const { PortDataSimulator } = await import('./src/data/PortDataSimulator.js');

                    // 初始化实例
                    console.log('🏗️ 创建图表生成器实例...');
                    this.chartGenerator = new DynamicChartGenerator();
                    console.log('🏗️ 创建数据模拟器实例...');
                    this.dataSimulator = new PortDataSimulator();

                    // 启动实时数据更新
                    console.log('⏰ 启动实时数据更新...');
                    this.dataSimulator.startRealTimeUpdates(30000); // 30秒更新一次

                    console.log('✅ 动态图表系统初始化成功');
                    console.log('系统状态:', {
                        chartGenerator: !!this.chartGenerator,
                        dataSimulator: !!this.dataSimulator
                    });
                } catch (error) {
                    console.error('❌ 动态图表系统初始化失败:', error);
                    console.error('错误详情:', error.message);
                    console.error('错误堆栈:', error.stack);
                }
            }



            initializePortDataContext() {
                return {
                    coreKPIs: {
                        containerThroughput: '2,847 TEU/日',
                        vesselTurnaround: '18.5小时',
                        craneProductivity: '28.6 moves/小时',
                        yardUtilization: '73.2%',
                        truckWaiting: '42分钟'
                    },
                    containerInventory: {
                        loadedContainers: '19,234 TEU',
                        emptyContainers: '8,012 TEU',
                        inTransit: '3,654 TEU',
                        turnoverRate: '3.8天/TEU',
                        dwellTime: '5.2天'
                    },
                    operationalInsights: {
                        peakHours: '06:00-18:00占总量78%',
                        topPerformingCranes: 'QC-03、QC-07效率领先',
                        bottlenecks: 'A区堆场接近饱和(89%)',
                        optimizationPotential: '空箱回收效率可提升18%'
                    },
                    industryStandards: {
                        vesselTurnaroundTarget: '<24小时',
                        craneProductivityRange: '25-35 moves/小时',
                        yardUtilizationSafe: '70-80%',
                        truckWaitingTarget: '<30分钟',
                        containerTurnoverAverage: '3-5天'
                    }
                };
            }

            async init() {
                this.setupEventListeners();
                this.setupResizeHandlers();
                this.setupChartHandlers();
                this.loadSampleData();

                // 异步初始化图表系统
                await this.initializeChartSystems();
            }

            setupEventListeners() {
                const toggleBtn = document.getElementById('ai-chat-toggle');
                const closeBtn = document.getElementById('ai-chat-close');
                const sendBtn = document.getElementById('ai-chat-send');
                const input = document.getElementById('ai-chat-input');
                const chatHeader = document.querySelector('.ai-chat-header');
                toggleBtn.addEventListener('click', () => this.toggleChat());
                closeBtn.addEventListener('click', () => this.closeChat());
                sendBtn.addEventListener('click', () => this.sendMessage());

                input.addEventListener('keypress', (e) => {
                    if (e.key === 'Enter') {
                        this.sendMessage();
                    }
                });

                // 添加窗口拖拽功能
                this.setupDragHandlers(chatHeader);
            }

            setupChartHandlers() {
                // 图表弹窗关闭按钮
                const chartClose = document.getElementById('chart-close');
                const chartModal = document.getElementById('chart-modal');

                chartClose.addEventListener('click', () => this.closeChart());
                chartModal.addEventListener('click', (e) => {
                    if (e.target === chartModal) {
                        this.closeChart();
                    }
                });


            }

            showChart(metric, title) {
                const chartModal = document.getElementById('chart-modal');
                const chartTitle = document.getElementById('chart-title');
                const chartContent = document.getElementById('chart-content');

                // 根据指标设置专业的图表标题
                const chartTitles = {
                    'container-throughput': '集装箱吞吐量趋势 (TEU)',
                    'vessel-turnaround': '船舶在港时间分析 (小时)',
                    'crane-productivity': '岸桥作业效率 (Moves/小时)',
                    'yard-utilization': '堆场利用率趋势 (%)',
                    'truck-waiting': '卡车平均等待时间 (分钟)',
                    'container-loaded': '重箱数量趋势 (TEU)',
                    'container-empty': '空箱数量趋势 (TEU)',
                    'container-transit': '运输中集装箱 (TEU)',
                    'container-turnover': '集装箱周转率 (天/TEU)',
                    'dwell-time': '平均停留时间 (天)',
                    // 兼容旧指标
                    'throughput': '集装箱吞吐量趋势 (TEU)',
                    'loading-time': '船舶在港时间分析 (小时)',
                    'equipment-utilization': '堆场利用率趋势 (%)',
                    'turnover-rate': '卡车平均等待时间 (分钟)',
                    'efficiency-improvement': '岸桥作业效率 (Moves/小时)'
                };

                chartTitle.textContent = chartTitles[metric] || `${title} - 数据分析`;
                chartModal.style.display = 'flex';

                // 初始化ECharts
                const chart = echarts.init(chartContent);
                const option = this.getChartOption(metric);
                chart.setOption(option);

                // 响应式调整
                window.addEventListener('resize', () => chart.resize());
            }

            closeChart() {
                const chartModal = document.getElementById('chart-modal');
                const chartContainer = chartModal.querySelector('.chart-container');

                // Mac风格关闭动画
                chartContainer.classList.add('closing');
                setTimeout(() => {
                    chartModal.style.display = 'none';
                    chartContainer.classList.remove('closing');
                }, 300);
            }

            getChartOption(metric) {
                // 生成最近7天的模拟数据
                const dates = [];
                const values = [];

                for (let i = 6; i >= 0; i--) {
                    const date = new Date();
                    date.setDate(date.getDate() - i);
                    dates.push(date.toLocaleDateString('zh-CN', { month: 'short', day: 'numeric' }));
                }

                // 根据不同指标生成真实的港口运营数据
                switch (metric) {
                    case 'container-throughput':
                        values.push(2654, 2789, 2543, 2912, 2678, 2834, 2847);
                        break;
                    case 'vessel-turnaround':
                        values.push(19.8, 18.2, 20.1, 17.6, 18.9, 17.8, 18.5);
                        break;
                    case 'crane-productivity':
                        values.push(26.8, 27.5, 25.9, 29.2, 28.1, 29.8, 28.6);
                        break;
                    case 'yard-utilization':
                        values.push(71.5, 74.2, 69.8, 76.1, 72.9, 75.3, 73.2);
                        break;
                    case 'truck-waiting':
                        values.push(48, 45, 52, 38, 44, 39, 42);
                        break;
                    case 'container-loaded':
                        values.push(18456, 19234, 17892, 20123, 18967, 19678, 19234);
                        break;
                    case 'container-empty':
                        values.push(8234, 7892, 8567, 7456, 8123, 7789, 8012);
                        break;
                    case 'container-transit':
                        values.push(3456, 3678, 3234, 3789, 3567, 3823, 3654);
                        break;
                    case 'container-turnover':
                        values.push(4.2, 3.9, 4.1, 3.6, 3.8, 3.7, 3.8);
                        break;
                    case 'dwell-time':
                        values.push(5.8, 5.3, 5.6, 4.9, 5.2, 5.0, 5.2);
                        break;
                    // 兼容旧指标
                    case 'throughput':
                        values.push(2654, 2789, 2543, 2912, 2678, 2834, 2847);
                        break;
                    case 'loading-time':
                        values.push(19.8, 18.2, 20.1, 17.6, 18.9, 17.8, 18.5);
                        break;
                    case 'equipment-utilization':
                        values.push(71.5, 74.2, 69.8, 76.1, 72.9, 75.3, 73.2);
                        break;
                    case 'turnover-rate':
                        values.push(48, 45, 52, 38, 44, 39, 42);
                        break;
                    case 'efficiency-improvement':
                        values.push(26.8, 27.5, 25.9, 29.2, 28.1, 29.8, 28.6);
                        break;
                    default:
                        values.push(2654, 2789, 2543, 2912, 2678, 2834, 2847);
                }

                return {
                    title: {
                        text: '数据趋势分析',
                        left: 'center',
                        top: 20,
                        textStyle: {
                            color: '#1e293b',
                            fontSize: 20,
                            fontWeight: 600,
                            fontFamily: 'Segoe UI, Microsoft YaHei, sans-serif'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: 'rgba(30, 41, 59, 0.95)',
                        borderColor: '#3b82f6',
                        borderWidth: 1,
                        textStyle: {
                            color: '#ffffff',
                            fontFamily: 'Segoe UI, Microsoft YaHei, sans-serif',
                            fontSize: 13
                        },
                        extraCssText: 'border-radius: 8px; box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);'
                    },
                    grid: {
                        left: '8%',
                        right: '5%',
                        bottom: '8%',
                        top: '15%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        data: dates,
                        axisLine: {
                            lineStyle: {
                                color: '#e2e8f0',
                                width: 1
                            }
                        },
                        axisLabel: {
                            color: '#64748b',
                            fontFamily: 'Segoe UI, Microsoft YaHei, sans-serif',
                            fontSize: 12
                        },
                        axisTick: {
                            show: false
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {
                            show: false
                        },
                        axisLabel: {
                            color: '#64748b',
                            fontFamily: 'Segoe UI, Microsoft YaHei, sans-serif',
                            fontSize: 12
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#f1f5f9',
                                width: 1
                            }
                        },
                        axisTick: {
                            show: false
                        }
                    },
                    series: [{
                        data: values,
                        type: 'line',
                        smooth: true,
                        symbol: 'circle',
                        symbolSize: 6,
                        lineStyle: {
                            color: '#3b82f6',
                            width: 3,
                            shadowColor: 'rgba(59, 130, 246, 0.3)',
                            shadowBlur: 8
                        },
                        itemStyle: {
                            color: '#3b82f6',
                            borderColor: '#ffffff',
                            borderWidth: 2,
                            shadowColor: 'rgba(59, 130, 246, 0.4)',
                            shadowBlur: 6
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: 'rgba(59, 130, 246, 0.3)'
                                }, {
                                    offset: 1,
                                    color: 'rgba(59, 130, 246, 0.05)'
                                }]
                            }
                        },
                        emphasis: {
                            itemStyle: {
                                color: '#1d4ed8',
                                borderColor: '#ffffff',
                                borderWidth: 3,
                                shadowColor: 'rgba(59, 130, 246, 0.6)',
                                shadowBlur: 12,
                                scale: 1.2
                            }
                        },
                        label: {
                            show: false
                        }
                    }]
                };
            }

            setupDragHandlers(dragElement) {
                let isDragging = false;
                let dragData = {};

                dragElement.addEventListener('mousedown', (e) => {
                    // 避免与关闭按钮冲突
                    if (e.target.classList.contains('ai-chat-close')) return;

                    e.preventDefault();
                    isDragging = true;

                    const chatWindow = document.getElementById('ai-chat-window');
                    const rect = chatWindow.getBoundingClientRect();

                    dragData = {
                        startX: e.clientX,
                        startY: e.clientY,
                        startLeft: rect.left,
                        startTop: rect.top
                    };

                    dragElement.style.cursor = 'grabbing';
                    document.body.style.userSelect = 'none';
                });

                document.addEventListener('mousemove', (e) => {
                    if (!isDragging) return;

                    e.preventDefault();
                    const chatWindow = document.getElementById('ai-chat-window');

                    const deltaX = e.clientX - dragData.startX;
                    const deltaY = e.clientY - dragData.startY;

                    let newLeft = dragData.startLeft + deltaX;
                    let newTop = dragData.startTop + deltaY;

                    // 限制窗口不超出屏幕边界
                    const windowWidth = chatWindow.offsetWidth;
                    const windowHeight = chatWindow.offsetHeight;
                    const screenWidth = window.innerWidth;
                    const screenHeight = window.innerHeight;

                    newLeft = Math.max(0, Math.min(screenWidth - windowWidth, newLeft));
                    newTop = Math.max(0, Math.min(screenHeight - windowHeight, newTop));

                    chatWindow.style.left = newLeft + 'px';
                    chatWindow.style.top = newTop + 'px';
                    chatWindow.style.right = 'auto';
                    chatWindow.style.bottom = 'auto';
                });

                document.addEventListener('mouseup', () => {
                    if (!isDragging) return;

                    isDragging = false;
                    dragData = {};
                    dragElement.style.cursor = '';
                    document.body.style.userSelect = '';
                });
            }

            setupResizeHandlers() {
                const chatWindow = document.getElementById('ai-chat-window');
                const resizeHandles = chatWindow.querySelectorAll('.resize-handle, .resize-indicator');

                resizeHandles.forEach(handle => {
                    handle.addEventListener('mousedown', (e) => this.startResize(e));
                });

                document.addEventListener('mousemove', (e) => this.handleResize(e));
                document.addEventListener('mouseup', () => this.stopResize());
            }

            startResize(e) {
                e.preventDefault();
                e.stopPropagation();
                this.isResizing = true;

                const chatWindow = document.getElementById('ai-chat-window');
                const rect = chatWindow.getBoundingClientRect();
                const direction = e.target.dataset.direction;

                this.resizeData = {
                    direction,
                    startX: e.clientX,
                    startY: e.clientY,
                    startWidth: rect.width,
                    startHeight: rect.height,
                    startLeft: rect.left,
                    startTop: rect.top
                };

                document.body.style.cursor = window.getComputedStyle(e.target).cursor;
                document.body.style.userSelect = 'none';
                chatWindow.style.transition = 'none';
            }

            handleResize(e) {
                if (!this.isResizing) return;

                e.preventDefault();
                const chatWindow = document.getElementById('ai-chat-window');
                const { direction, startX, startY, startWidth, startHeight, startLeft, startTop } = this.resizeData;

                const deltaX = e.clientX - startX;
                const deltaY = e.clientY - startY;

                let newWidth = startWidth;
                let newHeight = startHeight;
                let newLeft = startLeft;
                let newTop = startTop;

                // 获取屏幕尺寸
                const screenWidth = window.innerWidth;
                const screenHeight = window.innerHeight;
                const minWidth = 300;
                const minHeight = 350;

                // 根据拖拽方向调整尺寸和位置
                switch (direction) {
                    case 'n': // 上边
                        newHeight = Math.max(minHeight, Math.min(screenHeight - 50, startHeight - deltaY));
                        newTop = startTop + (startHeight - newHeight);
                        break;
                    case 'e': // 右边
                        newWidth = Math.max(minWidth, Math.min(screenWidth - 50, startWidth + deltaX));
                        break;
                    case 's': // 下边
                        newHeight = Math.max(minHeight, Math.min(screenHeight - 50, startHeight + deltaY));
                        break;
                    case 'w': // 左边
                        newWidth = Math.max(minWidth, Math.min(screenWidth - 50, startWidth - deltaX));
                        newLeft = startLeft + (startWidth - newWidth);
                        break;
                    case 'nw': // 左上角
                        newWidth = Math.max(minWidth, Math.min(screenWidth - 50, startWidth - deltaX));
                        newHeight = Math.max(minHeight, Math.min(screenHeight - 50, startHeight - deltaY));
                        newLeft = startLeft + (startWidth - newWidth);
                        newTop = startTop + (startHeight - newHeight);
                        break;
                    case 'ne': // 右上角
                        newWidth = Math.max(minWidth, Math.min(screenWidth - 50, startWidth + deltaX));
                        newHeight = Math.max(minHeight, Math.min(screenHeight - 50, startHeight - deltaY));
                        newTop = startTop + (startHeight - newHeight);
                        break;
                    case 'sw': // 左下角
                        newWidth = Math.max(minWidth, Math.min(screenWidth - 50, startWidth - deltaX));
                        newHeight = Math.max(minHeight, Math.min(screenHeight - 50, startHeight + deltaY));
                        newLeft = startLeft + (startWidth - newWidth);
                        break;
                    case 'se': // 右下角
                        newWidth = Math.max(minWidth, Math.min(screenWidth - 50, startWidth + deltaX));
                        newHeight = Math.max(minHeight, Math.min(screenHeight - 50, startHeight + deltaY));
                        break;
                }

                // 应用新尺寸和位置
                chatWindow.style.width = newWidth + 'px';
                chatWindow.style.height = newHeight + 'px';
                chatWindow.style.left = newLeft + 'px';
                chatWindow.style.top = newTop + 'px';
                chatWindow.style.right = 'auto';
                chatWindow.style.bottom = 'auto';
            }

            stopResize() {
                if (!this.isResizing) return;

                this.isResizing = false;
                this.resizeData = {};
                document.body.style.cursor = '';
                document.body.style.userSelect = '';

                const chatWindow = document.getElementById('ai-chat-window');
                chatWindow.style.transition = '';

                // 保存窗口大小到本地存储
                this.saveWindowSize();
            }

            saveWindowSize() {
                const chatWindow = document.getElementById('ai-chat-window');
                const size = {
                    width: chatWindow.offsetWidth,
                    height: chatWindow.offsetHeight
                };
                localStorage.setItem('ai-chat-window-size', JSON.stringify(size));
            }

            loadWindowSize() {
                const savedSize = localStorage.getItem('ai-chat-window-size');
                if (savedSize) {
                    try {
                        const size = JSON.parse(savedSize);
                        const chatWindow = document.getElementById('ai-chat-window');
                        chatWindow.style.width = size.width + 'px';
                        chatWindow.style.height = size.height + 'px';
                    } catch (e) {
                        console.log('无法加载保存的窗口大小');
                    }
                }
            }

            toggleChat() {
                const window = document.getElementById('ai-chat-window');
                this.isOpen = !this.isOpen;

                if (this.isOpen) {
                    window.style.display = 'flex';
                    window.classList.remove('closing');
                    this.loadWindowSize();
                    document.getElementById('ai-chat-input').focus();
                } else {
                    this.closeChat();
                }
            }

            closeChat() {
                const window = document.getElementById('ai-chat-window');
                this.isOpen = false;

                // 苹果风格关闭动画
                window.classList.add('closing');
                setTimeout(() => {
                    window.style.display = 'none';
                    window.classList.remove('closing');
                }, 300);
            }

            async sendMessage() {
                const input = document.getElementById('ai-chat-input');
                const message = input.value.trim();

                if (!message || this.isProcessing) return;

                // 隐藏欢迎信息
                const welcomeInfo = document.getElementById('welcome-info');
                if (welcomeInfo) {
                    welcomeInfo.style.display = 'none';
                }

                // 添加用户消息
                this.addMessage(message, 'user');
                input.value = '';
                this.isProcessing = true;

                // 显示加载状态
                this.showTypingIndicator();

                try {
                    // 调用DeepSeek API
                    const aiResponse = await this.callDeepSeekAPI(message);
                    this.hideTypingIndicator();
                    this.processDeepSeekResponse(aiResponse, message);
                } catch (error) {
                    console.error('DeepSeek API调用失败:', error);
                    this.hideTypingIndicator();
                    // 降级到本地处理
                    this.processAIResponse(message);
                }

                this.isProcessing = false;
            }

            async callDeepSeekAPI(userMessage) {
                const systemPrompt = this.buildSystemPrompt();

                const response = await fetch('https://api.deepseek.com/v1/chat/completions', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.deepseekApiKey}`
                    },
                    body: JSON.stringify({
                        model: 'deepseek-chat',
                        messages: [
                            {
                                role: 'system',
                                content: systemPrompt
                            },
                            {
                                role: 'user',
                                content: userMessage
                            }
                        ],
                        temperature: 0.7,
                        max_tokens: 1000
                    })
                });

                if (!response.ok) {
                    throw new Error(`API请求失败: ${response.status}`);
                }

                const data = await response.json();
                return data.choices[0].message.content;
            }

            buildSystemPrompt() {
                return `你是一个专业的港口运营AI助手，专门负责港口数据分析和运营优化。

当前港口数据上下文：
核心KPI指标：
- 集装箱吞吐量：${this.portDataContext.coreKPIs.containerThroughput}
- 船舶在港时间：${this.portDataContext.coreKPIs.vesselTurnaround}
- 岸桥作业效率：${this.portDataContext.coreKPIs.craneProductivity}
- 堆场利用率：${this.portDataContext.coreKPIs.yardUtilization}
- 卡车等待时间：${this.portDataContext.coreKPIs.truckWaiting}

集装箱库存：
- 重箱数量：${this.portDataContext.containerInventory.loadedContainers}
- 空箱数量：${this.portDataContext.containerInventory.emptyContainers}
- 运输中：${this.portDataContext.containerInventory.inTransit}
- 周转率：${this.portDataContext.containerInventory.turnoverRate}
- 停留时间：${this.portDataContext.containerInventory.dwellTime}

运营洞察：
- 高峰时段：${this.portDataContext.operationalInsights.peakHours}
- 高效设备：${this.portDataContext.operationalInsights.topPerformingCranes}
- 瓶颈问题：${this.portDataContext.operationalInsights.bottlenecks}
- 优化潜力：${this.portDataContext.operationalInsights.optimizationPotential}

行业标准：
- 船舶周转目标：${this.portDataContext.industryStandards.vesselTurnaroundTarget}
- 岸桥效率范围：${this.portDataContext.industryStandards.craneProductivityRange}
- 安全堆场利用率：${this.portDataContext.industryStandards.yardUtilizationSafe}
- 卡车等待目标：${this.portDataContext.industryStandards.truckWaitingTarget}

请基于以上真实数据回答用户问题，如果需要补充数据请生成符合实际港口运营的合理数值。
回答要专业、准确、简洁，包含具体数据和可操作的建议。
请使用清晰的格式，重要数据用粗体显示。`;
            }

            processDeepSeekResponse(response, originalMessage = '') {
                // 处理DeepSeek的回复，添加到聊天界面
                this.addMessage(response, 'ai');

                // 检查是否需要生成图表
                this.checkAndGenerateChart(originalMessage, response);
            }

            checkAndGenerateChart(userMessage, aiResponse) {
                console.log('🔍 检查是否需要生成图表:', userMessage);

                if (!this.isInitialized || !this.dataSimulator || !this.chartGenerator) {
                    console.log('❌ 图表系统未就绪');
                    return;
                }

                const message = userMessage.toLowerCase();
                console.log('🔍 处理消息:', message);

                // 检查是否是数据查询相关的消息
                if (message.includes('集装箱') || message.includes('container')) {
                    console.log('📦 触发集装箱查询');
                    setTimeout(() => this.handleContainerQuery(), 500);
                } else if (message.includes('起重机') || message.includes('crane') || message.includes('设备')) {
                    console.log('🏗️ 触发起重机查询');
                    setTimeout(() => this.handleCraneQuery(), 500);
                } else if (message.includes('船舶') || message.includes('ship') || message.includes('vessel')) {
                    console.log('🚢 触发船舶查询');
                    setTimeout(() => this.handleShipQuery(), 500);
                } else if (message.includes('数据分析') || message.includes('analysis') || message.includes('趋势')) {
                    console.log('📊 触发数据分析');
                    setTimeout(() => this.handleDataAnalysis(), 500);
                } else if (message.includes('性能') || message.includes('performance') || message.includes('效率')) {
                    console.log('⚡ 触发性能查询');
                    setTimeout(() => this.handlePerformanceQuery(), 500);
                } else {
                    console.log('ℹ️ 未匹配到图表生成条件');
                }
            }

            showTypingIndicator() {
                const messagesContainer = document.getElementById('ai-chat-messages');
                const typingDiv = document.createElement('div');
                typingDiv.className = 'ai-message ai typing-indicator';
                typingDiv.id = 'typing-indicator';
                typingDiv.innerHTML = `
                    <div class="ai-message-content">
                        <div class="typing-dots">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        正在分析港口数据...
                    </div>
                `;
                messagesContainer.appendChild(typingDiv);
                messagesContainer.scrollTop = messagesContainer.scrollHeight;
            }

            hideTypingIndicator() {
                const typingIndicator = document.getElementById('typing-indicator');
                if (typingIndicator) {
                    typingIndicator.remove();
                }
            }

            addMessage(content, type, imageUrl = null, data = null) {
                const messagesContainer = document.getElementById('ai-chat-messages');
                const messageDiv = document.createElement('div');
                messageDiv.className = `ai-message ${type}`;

                const currentTime = new Date().toLocaleTimeString('zh-CN', {
                    hour: '2-digit',
                    minute: '2-digit'
                });

                let messageHTML = '';

                if (type === 'ai') {
                    messageHTML += `
                        <div class="ai-message-header">
                            <span>智能港口助手系统</span>
                            <span class="ai-message-time">${currentTime}</span>
                        </div>
                    `;
                } else {
                    messageHTML += `
                        <div class="ai-message-header">
                            <span>用户</span>
                            <span class="ai-message-time">${currentTime}</span>
                        </div>
                    `;
                }

                messageHTML += `<div class="ai-message-content">${content}</div>`;

                if (imageUrl) {
                    messageHTML += `<img src="${imageUrl}" alt="港口数据可视化图表" class="ai-message-image" />`;
                }

                if (data) {
                    messageHTML += `<div class="ai-message-data">${this.formatDataDisplay(data)}</div>`;
                }

                messageDiv.innerHTML = messageHTML;
                messagesContainer.appendChild(messageDiv);
                messagesContainer.scrollTop = messagesContainer.scrollHeight;
            }

            formatDataDisplay(data) {
                return data.split('\n').map(line => {
                    if (line.includes(':')) {
                        const [label, value] = line.split(':');
                        return `<span class="data-label">${label.trim()}:</span> <span class="data-value">${value.trim()}</span>`;
                    }
                    return line;
                }).join('\n');
            }

            showTypingIndicator() {
                const messagesContainer = document.getElementById('ai-chat-messages');
                const typingDiv = document.createElement('div');
                typingDiv.className = 'ai-message ai typing-indicator';
                typingDiv.id = 'typing-indicator';
                typingDiv.innerHTML = '<div class="ai-message-content">AI正在思考中...</div>';
                messagesContainer.appendChild(typingDiv);
                messagesContainer.scrollTop = messagesContainer.scrollHeight;
            }

            hideTypingIndicator() {
                const typingIndicator = document.getElementById('typing-indicator');
                if (typingIndicator) {
                    typingIndicator.remove();
                }
            }

            processAIResponse(userMessage) {
                const lowerMessage = userMessage.toLowerCase();

                // 根据用户输入生成相应的回复
                if (lowerMessage.includes('集装箱') || lowerMessage.includes('container')) {
                    this.handleContainerQuery();
                } else if (lowerMessage.includes('起重机') || lowerMessage.includes('crane')) {
                    this.handleCraneQuery();
                } else if (lowerMessage.includes('船舶') || lowerMessage.includes('ship')) {
                    this.handleShipQuery();
                } else if (lowerMessage.includes('数据') || lowerMessage.includes('统计') || lowerMessage.includes('分析')) {
                    this.handleDataAnalysis();
                } else if (lowerMessage.includes('效率') || lowerMessage.includes('性能')) {
                    this.handlePerformanceQuery();
                } else {
                    this.handleGeneralQuery();
                }
            }

            loadSampleData() {
                // 使用动态数据模拟器，不再使用硬编码数据
                console.log('✅ 动态数据系统已启用，数据将实时更新');
            }

            generateChartImage(type) {
                // 创建一个简单的Canvas图表
                const canvas = document.createElement('canvas');
                canvas.width = 300;
                canvas.height = 200;
                const ctx = canvas.getContext('2d');

                // 背景渐变
                const gradient = ctx.createLinearGradient(0, 0, 0, 200);
                if (type === 'analytics') {
                    gradient.addColorStop(0, '#667eea');
                    gradient.addColorStop(1, '#764ba2');
                } else {
                    gradient.addColorStop(0, '#f093fb');
                    gradient.addColorStop(1, '#f5576c');
                }
                ctx.fillStyle = gradient;
                ctx.fillRect(0, 0, 300, 200);

                // 标题
                ctx.fillStyle = 'white';
                ctx.font = 'bold 16px Arial';
                ctx.textAlign = 'center';
                const title = type === 'analytics' ? '港口数据分析图表' : '设备性能监控图';
                ctx.fillText(title, 150, 30);

                // 绘制改进的柱状图
                ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
                const bars = type === 'analytics' ? [65, 78, 52, 89, 73] : [72, 85, 68, 91, 76];
                const barWidth = 35;
                const barSpacing = 15;
                const startX = 40;

                bars.forEach((height, index) => {
                    const x = startX + index * (barWidth + barSpacing);
                    const y = 160 - height;

                    // 绘制柱子
                    ctx.fillRect(x, y, barWidth, height);

                    // 添加柱子顶部高光
                    ctx.fillStyle = 'rgba(255, 255, 255, 1)';
                    ctx.fillRect(x, y, barWidth, 3);

                    // 数值标签
                    ctx.fillStyle = 'white';
                    ctx.font = 'bold 12px Arial';
                    ctx.textAlign = 'center';
                    ctx.fillText(height + '%', x + barWidth/2, y - 8);

                    // 重置填充样式
                    ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
                });

                // 添加底部标签
                ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
                ctx.font = '10px Arial';
                ctx.textAlign = 'center';
                const labels = ['周一', '周二', '周三', '周四', '周五'];
                labels.forEach((label, index) => {
                    const x = startX + index * (barWidth + barSpacing) + barWidth/2;
                    ctx.fillText(label, x, 180);
                });

                // 添加时间戳和类型标识
                ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
                ctx.font = '9px Arial';
                ctx.textAlign = 'right';
                ctx.fillText(`${type === 'analytics' ? '数据分析' : '性能监控'} | ${new Date().toLocaleTimeString()}`, 290, 195);

                return canvas.toDataURL();
            }

            generateContainerChart(data) {
                const canvas = document.createElement('canvas');
                canvas.width = 300;
                canvas.height = 200;
                const ctx = canvas.getContext('2d');

                // 背景渐变
                const gradient = ctx.createLinearGradient(0, 0, 0, 200);
                gradient.addColorStop(0, '#2c3e50');
                gradient.addColorStop(1, '#34495e');
                ctx.fillStyle = gradient;
                ctx.fillRect(0, 0, 300, 200);

                // 标题
                ctx.fillStyle = '#ecf0f1';
                ctx.font = 'bold 14px Arial';
                ctx.textAlign = 'center';
                ctx.fillText('集装箱分布状态图', 150, 25);

                // 绘制饼图数据
                const total = data.total;
                const centerX = 150;
                const centerY = 110;
                const radius = 60;

                let currentAngle = -Math.PI / 2;

                // 重箱 (绿色)
                const loadedAngle = (data.loaded / total) * 2 * Math.PI;
                ctx.fillStyle = '#2ecc71';
                ctx.beginPath();
                ctx.moveTo(centerX, centerY);
                ctx.arc(centerX, centerY, radius, currentAngle, currentAngle + loadedAngle);
                ctx.closePath();
                ctx.fill();
                currentAngle += loadedAngle;

                // 空箱 (蓝色)
                const emptyAngle = (data.empty / total) * 2 * Math.PI;
                ctx.fillStyle = '#3498db';
                ctx.beginPath();
                ctx.moveTo(centerX, centerY);
                ctx.arc(centerX, centerY, radius, currentAngle, currentAngle + emptyAngle);
                ctx.closePath();
                ctx.fill();
                currentAngle += emptyAngle;

                // 运输中 (橙色)
                const transitAngle = (data.inTransit / total) * 2 * Math.PI;
                ctx.fillStyle = '#f39c12';
                ctx.beginPath();
                ctx.moveTo(centerX, centerY);
                ctx.arc(centerX, centerY, radius, currentAngle, currentAngle + transitAngle);
                ctx.closePath();
                ctx.fill();

                // 图例
                ctx.font = '11px Arial';
                ctx.textAlign = 'left';

                ctx.fillStyle = '#2ecc71';
                ctx.fillRect(20, 175, 12, 8);
                ctx.fillStyle = '#ecf0f1';
                ctx.fillText(`重箱 ${((data.loaded/total)*100).toFixed(1)}%`, 35, 182);

                ctx.fillStyle = '#3498db';
                ctx.fillRect(110, 175, 12, 8);
                ctx.fillStyle = '#ecf0f1';
                ctx.fillText(`空箱 ${((data.empty/total)*100).toFixed(1)}%`, 125, 182);

                ctx.fillStyle = '#f39c12';
                ctx.fillRect(200, 175, 12, 8);
                ctx.fillStyle = '#ecf0f1';
                ctx.fillText(`运输 ${((data.inTransit/total)*100).toFixed(1)}%`, 215, 182);

                return canvas.toDataURL();
            }

            generateCraneChart(data) {
                const canvas = document.createElement('canvas');
                canvas.width = 300;
                canvas.height = 200;
                const ctx = canvas.getContext('2d');

                // 背景
                const gradient = ctx.createLinearGradient(0, 0, 0, 200);
                gradient.addColorStop(0, '#34495e');
                gradient.addColorStop(1, '#2c3e50');
                ctx.fillStyle = gradient;
                ctx.fillRect(0, 0, 300, 200);

                // 标题
                ctx.fillStyle = '#ecf0f1';
                ctx.font = 'bold 14px Arial';
                ctx.textAlign = 'center';
                ctx.fillText('起重机设备状态监控', 150, 25);

                // 绘制柱状图
                const barWidth = 50;
                const barSpacing = 20;
                const startX = 50;
                const maxHeight = 120;
                const baseY = 160;

                // 作业中 (绿色)
                const activeHeight = (data.active / data.total) * maxHeight;
                ctx.fillStyle = '#2ecc71';
                ctx.fillRect(startX, baseY - activeHeight, barWidth, activeHeight);
                ctx.fillStyle = '#ecf0f1';
                ctx.font = '12px Arial';
                ctx.textAlign = 'center';
                ctx.fillText('作业中', startX + barWidth/2, baseY + 15);
                ctx.fillText(data.active, startX + barWidth/2, baseY - activeHeight - 5);

                // 维护中 (橙色)
                const maintenanceHeight = (data.maintenance / data.total) * maxHeight;
                ctx.fillStyle = '#f39c12';
                ctx.fillRect(startX + barWidth + barSpacing, baseY - maintenanceHeight, barWidth, maintenanceHeight);
                ctx.fillStyle = '#ecf0f1';
                ctx.fillText('维护中', startX + barWidth + barSpacing + barWidth/2, baseY + 15);
                ctx.fillText(data.maintenance, startX + barWidth + barSpacing + barWidth/2, baseY - maintenanceHeight - 5);

                // 空闲 (蓝色)
                const idleHeight = (data.idle / data.total) * maxHeight;
                ctx.fillStyle = '#3498db';
                ctx.fillRect(startX + (barWidth + barSpacing) * 2, baseY - idleHeight, barWidth, idleHeight);
                ctx.fillStyle = '#ecf0f1';
                ctx.fillText('待机', startX + (barWidth + barSpacing) * 2 + barWidth/2, baseY + 15);
                ctx.fillText(data.idle, startX + (barWidth + barSpacing) * 2 + barWidth/2, baseY - idleHeight - 5);

                // 添加效率指示器
                ctx.fillStyle = '#95a5a6';
                ctx.font = '10px Arial';
                ctx.textAlign = 'right';
                ctx.fillText(`利用率: ${((data.active/data.total)*100).toFixed(1)}%`, 290, 185);
                ctx.fillText(`更新时间: ${new Date().toLocaleTimeString()}`, 290, 195);

                return canvas.toDataURL();
            }

            generateShipChart(data) {
                const canvas = document.createElement('canvas');
                canvas.width = 300;
                canvas.height = 200;
                const ctx = canvas.getContext('2d');

                // 背景渐变
                const gradient = ctx.createLinearGradient(0, 0, 0, 200);
                gradient.addColorStop(0, '#1e3c72');
                gradient.addColorStop(1, '#2a5298');
                ctx.fillStyle = gradient;
                ctx.fillRect(0, 0, 300, 200);

                // 标题
                ctx.fillStyle = '#ecf0f1';
                ctx.font = 'bold 14px Arial';
                ctx.textAlign = 'center';
                ctx.fillText('船舶作业状态监控', 150, 25);

                // 绘制船舶状态图
                const centerX = 150;
                const centerY = 110;
                const radius = 50;

                let currentAngle = -Math.PI / 2;

                // 作业中 (绿色)
                const loadingAngle = (data.loading / data.inPort) * 2 * Math.PI;
                ctx.fillStyle = '#27ae60';
                ctx.beginPath();
                ctx.moveTo(centerX, centerY);
                ctx.arc(centerX, centerY, radius, currentAngle, currentAngle + loadingAngle);
                ctx.closePath();
                ctx.fill();
                currentAngle += loadingAngle;

                // 等待中 (橙色)
                const waitingAngle = (data.waiting / data.inPort) * 2 * Math.PI;
                ctx.fillStyle = '#f39c12';
                ctx.beginPath();
                ctx.moveTo(centerX, centerY);
                ctx.arc(centerX, centerY, radius, currentAngle, currentAngle + waitingAngle);
                ctx.closePath();
                ctx.fill();

                // 中心文字
                ctx.fillStyle = '#ecf0f1';
                ctx.font = 'bold 16px Arial';
                ctx.textAlign = 'center';
                ctx.fillText(data.inPort, centerX, centerY - 5);
                ctx.font = '10px Arial';
                ctx.fillText('艘船舶', centerX, centerY + 10);

                // 图例
                ctx.font = '11px Arial';
                ctx.textAlign = 'left';

                ctx.fillStyle = '#27ae60';
                ctx.fillRect(20, 175, 12, 8);
                ctx.fillStyle = '#ecf0f1';
                ctx.fillText(`作业中 ${data.loading}艘`, 35, 182);

                ctx.fillStyle = '#f39c12';
                ctx.fillRect(120, 175, 12, 8);
                ctx.fillStyle = '#ecf0f1';
                ctx.fillText(`等待中 ${data.waiting}艘`, 135, 182);

                // 添加状态信息
                ctx.fillStyle = '#95a5a6';
                ctx.font = '10px Arial';
                ctx.textAlign = 'right';
                ctx.fillText(`平均等待: 45分钟`, 290, 185);
                ctx.fillText(`更新时间: ${new Date().toLocaleTimeString()}`, 290, 195);

                return canvas.toDataURL();
            }

            handleContainerQuery() {
                // 检查图表系统是否已初始化
                if (!this.isInitialized || !this.dataSimulator || !this.chartGenerator) {
                    console.log('图表系统状态:', {
                        isInitialized: this.isInitialized,
                        dataSimulator: !!this.dataSimulator,
                        chartGenerator: !!this.chartGenerator
                    });
                    this.addMessage('⏳ 图表系统正在初始化中，请稍后再试...', 'ai');
                    return;
                }

                // 获取实时集装箱数据
                const data = this.dataSimulator.getContainerData();
                const loadingRate = data.loadingRate;
                const emptyRate = ((data.empty/data.total)*100).toFixed(1);
                const transitRate = ((data.inTransit/data.total)*100).toFixed(1);

                const response = `集装箱运营状态分析报告

当前库存概况（实时数据）
港口集装箱总量：**${data.total.toLocaleString()} TEU**
• 重箱（已装载）：**${data.loaded.toLocaleString()} TEU** (${loadingRate}%)
• 空箱（待装载）：**${data.empty.toLocaleString()} TEU** (${emptyRate}%)
• 运输中：**${data.inTransit.toLocaleString()} TEU** (${transitRate}%)

运营关键指标
• 堆场利用率：**${data.utilizationRate}%**
• 装载率：**${data.loadingRate}%**
• 堆场容量：**${data.capacity.toLocaleString()} TEU**
• 剩余容量：**${(data.capacity - data.total).toLocaleString()} TEU**

系统优化建议
${this.generateContainerRecommendations(data)}`;

                const dataDisplay = `集装箱总量: ${data.total.toLocaleString()} TEU
重箱数量: ${data.loaded.toLocaleString()} TEU
空箱数量: ${data.empty.toLocaleString()} TEU
运输中: ${data.inTransit.toLocaleString()} TEU
装载率: ${loadingRate}%
堆场利用率: ${data.utilizationRate}%
堆场容量: ${data.capacity.toLocaleString()} TEU
更新时间: ${new Date().toLocaleTimeString()}`;

                // 使用动态图表生成器生成实时图表
                const chartImage = this.chartGenerator.generateContainerChart(data);
                this.addMessage(response, 'ai', chartImage, dataDisplay);
            }

            generateContainerRecommendations(data) {
                const recommendations = [];
                const utilizationRate = parseFloat(data.utilizationRate);

                if (utilizationRate > 85) {
                    recommendations.push('1. ⚠️ 堆场利用率过高，建议启用备用堆场区域');
                } else if (utilizationRate < 60) {
                    recommendations.push('1. 💡 堆场利用率较低，可考虑优化堆场布局');
                } else {
                    recommendations.push('1. ✅ 堆场利用率正常，继续保持');
                }

                const emptyRate = (data.empty / data.total) * 100;
                if (emptyRate > 40) {
                    recommendations.push('2. 📦 空箱比例较高，建议加强空箱回收调度');
                }

                const loadingRate = parseFloat(data.loadingRate);
                if (loadingRate < 50) {
                    recommendations.push('3. 🚛 重箱比例偏低，建议关注进箱计划');
                }

                return recommendations.join('\n');
            }

            handleCraneQuery() {
                // 检查图表系统是否已初始化
                if (!this.isInitialized || !this.dataSimulator || !this.chartGenerator) {
                    this.addMessage('⏳ 图表系统正在初始化中，请稍后再试...', 'ai');
                    return;
                }

                // 获取实时起重机数据
                const data = this.dataSimulator.getCraneData();
                const utilizationRate = data.utilizationRate;
                const maintenanceRate = data.maintenanceRate;
                const idleRate = ((data.idle/data.total)*100).toFixed(1);

                const response = `港口起重机设备监控报告（实时数据）

设备运行总览
港口起重机总数：**${data.total} 台**
• 正在作业：**${data.active} 台** (${utilizationRate}%)
• 计划维护：**${data.maintenance} 台** (${maintenanceRate}%)
• 待机状态：**${data.idle} 台** (${idleRate}%)

设备分类详情
${this.generateCraneDetails(data)}

关键性能指标
• 平均作业效率：**${data.efficiency} moves/小时**
• 设备利用率：**${utilizationRate}%**
• 维护率：**${maintenanceRate}%**
• 设备可用率：**${(100 - parseFloat(maintenanceRate)).toFixed(1)}%**

维护管理建议
${this.generateCraneRecommendations(data)}`;

                const dataDisplay = `起重机总数: ${data.total} 台
作业中: ${data.active} 台
维护中: ${data.maintenance} 台
待机: ${data.idle} 台
设备利用率: ${utilizationRate}%
作业效率: ${data.efficiency} moves/h
设备可用率: ${(100 - parseFloat(maintenanceRate)).toFixed(1)}%
更新时间: ${new Date().toLocaleTimeString()}`;

                // 使用动态图表生成器生成实时图表
                const chartImage = this.chartGenerator.generateCraneChart(data);
                this.addMessage(response, 'ai', chartImage, dataDisplay);
            }

            generateCraneDetails(data) {
                const details = [];
                const activeRatio = data.active / data.total;

                if (data.total >= 6) {
                    const stsActive = Math.round(4 * activeRatio);
                    const rtgActive = Math.round(3 * activeRatio);
                    const rmgActive = Math.round(1 * activeRatio);

                    details.push(`• STS岸桥：4台 (${stsActive}台作业中，${4-stsActive}台待机)`);
                    details.push(`• RTG轮胎吊：3台 (${rtgActive}台作业中，${3-rtgActive}台待机)`);
                    details.push(`• RMG轨道吊：1台 (${rmgActive}台作业中，${1-rmgActive}台待机)`);
                } else {
                    details.push(`• 设备详情：${data.active}台作业中，${data.idle}台待机，${data.maintenance}台维护中`);
                }

                return details.join('\n');
            }

            generateCraneRecommendations(data) {
                const recommendations = [];
                const utilizationRate = parseFloat(data.utilizationRate);

                if (utilizationRate > 90) {
                    recommendations.push('1. ⚠️ 设备利用率过高，建议安排轮换作业避免过度使用');
                } else if (utilizationRate < 60) {
                    recommendations.push('1. 💡 设备利用率偏低，可考虑优化作业调度');
                } else {
                    recommendations.push('1. ✅ 设备利用率正常，继续保持');
                }

                if (data.maintenance > 0) {
                    recommendations.push(`2. 🔧 ${data.maintenance}台设备正在维护，预计完成时间：${this.getMaintenanceEstimate()}`);
                }

                if (data.idle > 2) {
                    recommendations.push('3. 📈 建议增加夜班作业人员配置，提高设备利用率');
                }

                return recommendations.join('\n');
            }

            getMaintenanceEstimate() {
                const hours = 2 + Math.random() * 6;
                return `${hours.toFixed(1)}小时后`;
            }

            handleShipQuery() {
                // 检查图表系统是否已初始化
                if (!this.isInitialized || !this.dataSimulator || !this.chartGenerator) {
                    this.addMessage('⏳ 图表系统正在初始化中，请稍后再试...', 'ai');
                    return;
                }

                // 获取实时船舶数据
                const data = this.dataSimulator.getShipData();

                const response = `船舶作业状态监控（实时数据）

港口船舶概况
港口内共有 **${data.inPort} 艘船舶**
• 装卸作业中：**${data.loading} 艘**
• 等待泊位：**${data.waiting} 艘**
• 已完成作业：**${data.completed} 艘**

作业进度信息
• 作业率：**${data.loadingRate}%**
• 平均等待时间：**${data.averageWaitTime} 分钟**
• 预计完成时间：**${this.formatEstimatedCompletion(data.estimatedCompletion)}**

船舶作业详情
${this.generateShipDetails(data)}

调度优化建议
${this.generateShipRecommendations(data)}`;

                const dataDisplay = `港内船舶: ${data.inPort} 艘
作业中: ${data.loading} 艘
等待中: ${data.waiting} 艘
已完成: ${data.completed} 艘
作业率: ${data.loadingRate}%
平均等待: ${data.averageWaitTime} 分钟
更新时间: ${new Date().toLocaleTimeString()}`;

                // 使用动态图表生成器生成实时图表
                const chartImage = this.chartGenerator.generateShipChart(data);
                this.addMessage(response, 'ai', chartImage, dataDisplay);
            }

            formatEstimatedCompletion(estimations) {
                if (!estimations || estimations.length === 0) {
                    return '暂无作业船舶';
                }
                return estimations.map((time, index) => `船舶${index + 1}: ${time}`).join('\n');
            }

            generateShipDetails(data) {
                const details = [];
                const shipNames = ['海洋之星', '蓝色巨人', '东方明珠', '南海之光', '北极星'];

                for (let i = 0; i < data.loading; i++) {
                    const name = shipNames[i % shipNames.length];
                    const completion = data.estimatedCompletion[i] || '未知';
                    details.push(`• "${name}"号：装卸作业中，预计${completion}完成`);
                }

                for (let i = 0; i < data.waiting; i++) {
                    const name = shipNames[(data.loading + i) % shipNames.length];
                    details.push(`• "${name}"号：等待泊位分配`);
                }

                return details.length > 0 ? details.join('\n') : '暂无船舶在港';
            }

            generateShipRecommendations(data) {
                const recommendations = [];

                if (data.waiting > 1) {
                    recommendations.push('1. ⚠️ 等待船舶较多，建议优化泊位调度，减少等待时间');
                } else if (data.waiting === 0 && data.loading > 0) {
                    recommendations.push('1. ✅ 泊位利用充分，无船舶等待');
                } else {
                    recommendations.push('1. 💡 港口运营正常，继续保持');
                }

                if (data.averageWaitTime > 60) {
                    recommendations.push('2. ⏱️ 平均等待时间较长，建议加快装卸作业效率');
                }

                const loadingRate = parseFloat(data.loadingRate);
                if (loadingRate < 50 && data.inPort > 2) {
                    recommendations.push('3. 📈 建议增加作业人员，提高船舶作业率');
                }

                return recommendations.join('\n');
            }

            handleDataAnalysis() {
                // 检查图表系统是否已初始化
                if (!this.isInitialized || !this.dataSimulator || !this.chartGenerator) {
                    this.addMessage('⏳ 图表系统正在初始化中，请稍后再试...', 'ai');
                    return;
                }

                // 获取实时性能数据和趋势数据
                const performanceData = this.dataSimulator.getPerformanceData();
                const trendData = this.dataSimulator.getTrendData('throughput', 7);
                const comparisonData = this.dataSimulator.getComparisonData();

                const response = `港口运营数据分析报告（实时数据）

基于最近7天的运营数据分析：

核心KPI指标（当前值）：
• 集装箱吞吐量：**${performanceData.throughput.toLocaleString()} TEU/日**
• 船舶平均在港时间：**${performanceData.vesselTurnaround}小时**
• 堆场利用率：**${performanceData.yardUtilization}%**
• 卡车平均等待时间：**${performanceData.truckWaitTime}分钟**
• 综合运营效率：**${performanceData.overallEfficiency}%**

趋势对比分析：
${this.generateTrendAnalysis(comparisonData)}

运营洞察：
${this.generateOperationalInsights(performanceData, trendData)}

智能优化建议：
${this.generateDataAnalysisRecommendations(performanceData, comparisonData)}`;

                const dataDisplay = `集装箱吞吐量: ${performanceData.throughput.toLocaleString()} TEU/日
船舶在港时间: ${performanceData.vesselTurnaround} 小时
堆场利用率: ${performanceData.yardUtilization}%
卡车等待时间: ${performanceData.truckWaitTime} 分钟
综合效率: ${performanceData.overallEfficiency}%
数据更新: ${new Date().toLocaleTimeString()}`;

                // 生成趋势分析图表
                const chartImage = this.chartGenerator.generateEfficiencyTrendChart(trendData);
                this.addMessage(response, 'ai', chartImage, dataDisplay);
            }

            generateTrendAnalysis(comparisonData) {
                const analysis = [];
                const current = comparisonData.current;
                const lastWeek = comparisonData.lastWeek;

                const throughputChange = ((current.throughput - lastWeek.throughput) / lastWeek.throughput * 100).toFixed(1);
                const efficiencyChange = (current.efficiency - lastWeek.efficiency).toFixed(1);
                const utilizationChange = (current.utilization - lastWeek.utilization).toFixed(1);

                analysis.push(`• 吞吐量较上周${throughputChange > 0 ? '增长' : '下降'}${Math.abs(throughputChange)}%`);
                analysis.push(`• 运营效率较上周${efficiencyChange > 0 ? '提升' : '下降'}${Math.abs(efficiencyChange)}%`);
                analysis.push(`• 堆场利用率较上周${utilizationChange > 0 ? '提高' : '降低'}${Math.abs(utilizationChange)}%`);

                return analysis.join('\n');
            }

            generateOperationalInsights(performanceData, trendData) {
                const insights = [];

                // 分析吞吐量趋势
                const recentTrend = trendData.slice(-3);
                const isIncreasing = recentTrend.every((item, index) =>
                    index === 0 || item.value >= recentTrend[index - 1].value
                );

                if (isIncreasing) {
                    insights.push('• 📈 吞吐量呈上升趋势，港口运营状况良好');
                } else {
                    insights.push('• 📉 吞吐量有所波动，需关注运营效率');
                }

                // 分析堆场利用率
                const utilization = parseFloat(performanceData.yardUtilization);
                if (utilization > 80) {
                    insights.push('• ⚠️ 堆场利用率较高，建议优化空间配置');
                } else if (utilization < 60) {
                    insights.push('• 💡 堆场利用率偏低，有优化空间');
                } else {
                    insights.push('• ✅ 堆场利用率适中，运营平稳');
                }

                // 分析等待时间
                if (performanceData.truckWaitTime > 50) {
                    insights.push('• 🚛 卡车等待时间较长，建议优化调度流程');
                }

                return insights.join('\n');
            }

            generateDataAnalysisRecommendations(performanceData, comparisonData) {
                const recommendations = [];

                if (parseFloat(performanceData.overallEfficiency) < 80) {
                    recommendations.push('1. 📊 综合效率偏低，建议全面优化作业流程');
                } else {
                    recommendations.push('1. ✅ 综合效率良好，继续保持优化');
                }

                if (performanceData.truckWaitTime > 45) {
                    recommendations.push('2. 🚛 实施智能预约系统，减少卡车排队等待');
                }

                if (parseFloat(performanceData.yardUtilization) > 85) {
                    recommendations.push('3. 📦 考虑扩展堆场容量或优化堆场布局');
                }

                const throughputTrend = comparisonData.current.throughput - comparisonData.lastWeek.throughput;
                if (throughputTrend < 0) {
                    recommendations.push('4. 📈 吞吐量下降，建议分析原因并制定改进措施');
                }

                return recommendations.join('\n');
            }

            handlePerformanceQuery() {
                // 检查图表系统是否已初始化
                if (!this.isInitialized || !this.dataSimulator || !this.chartGenerator) {
                    this.addMessage('⏳ 图表系统正在初始化中，请稍后再试...', 'ai');
                    return;
                }

                // 获取实时性能数据
                const performanceData = this.dataSimulator.getPerformanceData();
                const containerData = this.dataSimulator.getContainerData();
                const craneData = this.dataSimulator.getCraneData();
                const comparisonData = this.dataSimulator.getComparisonData();

                const response = `港口性能监控报告（实时数据）

整体运营效率：**${performanceData.overallEfficiency}%**

详细性能指标：
• 集装箱装载效率：**${containerData.loadingRate}%** ${this.getEfficiencyStatus(parseFloat(containerData.loadingRate))}
• 设备利用效率：**${craneData.utilizationRate}%** ${this.getEfficiencyStatus(parseFloat(craneData.utilizationRate))}
• 堆场利用效率：**${performanceData.yardUtilization}%** ${this.getEfficiencyStatus(parseFloat(performanceData.yardUtilization))}
• 作业效率：**${craneData.efficiency} moves/h**

性能对比分析：
${this.generatePerformanceComparison(performanceData, comparisonData)}

效率趋势：
${this.generateEfficiencyTrend(performanceData)}

性能优化建议：
${this.generatePerformanceRecommendations(performanceData, containerData, craneData)}`;

                const dataDisplay = `整体效率: ${performanceData.overallEfficiency}%
装载效率: ${containerData.loadingRate}%
设备利用率: ${craneData.utilizationRate}%
堆场利用率: ${performanceData.yardUtilization}%
作业效率: ${craneData.efficiency} moves/h
数据更新: ${new Date().toLocaleTimeString()}`;

                // 生成性能对比图表
                const chartData = [
                    { name: '装载效率', value: parseFloat(containerData.loadingRate) },
                    { name: '设备利用率', value: parseFloat(craneData.utilizationRate) },
                    { name: '堆场利用率', value: parseFloat(performanceData.yardUtilization) },
                    { name: '综合效率', value: parseFloat(performanceData.overallEfficiency) }
                ];
                const chartImage = this.chartGenerator.generateThroughputChart(chartData);
                this.addMessage(response, 'ai', chartImage, dataDisplay);
            }

            getEfficiencyStatus(value) {
                if (value >= 85) return '✅';
                else if (value >= 70) return '⚠️';
                else return '❌';
            }

            generatePerformanceComparison(current, comparison) {
                const comparisons = [];

                const currentEff = parseFloat(current.overallEfficiency);
                const lastWeekEff = comparison.lastWeek.efficiency || currentEff;
                const change = ((currentEff - lastWeekEff) / lastWeekEff * 100).toFixed(1);

                comparisons.push(`• 较上周${change > 0 ? '提升' : '下降'}：${Math.abs(change)}%`);

                if (currentEff >= 85) {
                    comparisons.push('• 行业水平：优秀（Top 20%）');
                } else if (currentEff >= 75) {
                    comparisons.push('• 行业水平：良好（Top 40%）');
                } else {
                    comparisons.push('• 行业水平：需改进');
                }

                const targetRate = (currentEff / 90 * 100).toFixed(1); // 假设目标是90%
                comparisons.push(`• 目标达成率：${targetRate}%`);

                return comparisons.join('\n');
            }

            generateEfficiencyTrend(performanceData) {
                const trends = [];
                const efficiency = parseFloat(performanceData.overallEfficiency);

                if (efficiency > 80) {
                    trends.push('• 📈 整体效率保持高位，运营状况优良');
                } else if (efficiency > 70) {
                    trends.push('• 📊 整体效率中等，有提升空间');
                } else {
                    trends.push('• 📉 整体效率偏低，需要重点改进');
                }

                const utilization = parseFloat(performanceData.yardUtilization);
                if (utilization > 80) {
                    trends.push('• 🏗️ 堆场利用率高，资源配置合理');
                } else {
                    trends.push('• 💡 堆场利用率有优化空间');
                }

                return trends.join('\n');
            }

            generatePerformanceRecommendations(performance, container, crane) {
                const recommendations = [];

                const overallEff = parseFloat(performance.overallEfficiency);
                if (overallEff < 75) {
                    recommendations.push('1. 🎯 整体效率偏低，建议全面分析瓶颈环节');
                } else if (overallEff < 85) {
                    recommendations.push('1. 📈 效率良好，继续优化关键环节');
                } else {
                    recommendations.push('1. ✅ 效率优秀，保持当前运营水平');
                }

                const loadingRate = parseFloat(container.loadingRate);
                if (loadingRate < 60) {
                    recommendations.push('2. 📦 重箱比例偏低，建议优化进箱计划');
                }

                const craneUtil = parseFloat(crane.utilizationRate);
                if (craneUtil < 70) {
                    recommendations.push('3. 🏗️ 设备利用率偏低，建议优化作业调度');
                } else if (craneUtil > 90) {
                    recommendations.push('3. ⚠️ 设备利用率过高，注意设备保养');
                }

                if (performance.truckWaitTime > 45) {
                    recommendations.push('4. 🚛 卡车等待时间较长，建议实施智能调度');
                }

                return recommendations.join('\n');
            }

            handleGeneralQuery() {
                const responses = [
                    "我可以帮您查询港口的各种信息，比如集装箱状态、起重机运行情况、船舶作业进度等。请告诉我您想了解什么？",
                    "作为AI港口助手，我能为您提供实时数据分析、设备监控和运营建议。您可以询问关于集装箱、起重机、船舶或港口效率的任何问题。",
                    "您好！我可以协助您进行港口数据查询和分析。常见的查询包括：集装箱分布、设备状态、船舶调度、效率分析等。"
                ];

                const randomResponse = responses[Math.floor(Math.random() * responses.length)];
                this.addMessage(randomResponse, 'ai');
            }
        }

        // 页面加载完成后开始
        document.addEventListener('DOMContentLoaded', () => {
            if (checkCompatibility()) {
                // 初始化AI助手
                window.aiAssistant = new AIPortAssistant();

                // 添加查询标签点击事件
                document.querySelectorAll('.query-tag').forEach(tag => {
                    tag.addEventListener('click', () => {
                        const input = document.getElementById('ai-chat-input');
                        input.value = tag.textContent;
                        window.aiAssistant.sendMessage();
                    });
                });

                // 开始模拟加载
                setTimeout(simulateLoading, 1000);
            } else {
                // 显示兼容性错误
                const loadingContent = document.querySelector('.loading-content');
                if (loadingContent) {
                    loadingContent.innerHTML = `
                        <h2 style="color: #ff5252; margin-bottom: 20px;">⚠️ 浏览器不兼容</h2>
                        <p style="margin-bottom: 20px;">您的浏览器不支持WebGL 2.0，无法运行此应用。</p>
                        <p style="margin-bottom: 30px;">请使用以下浏览器的最新版本：</p>
                        <ul style="text-align: left; margin-bottom: 30px; line-height: 1.8;">
                            <li>Google Chrome 90+</li>
                            <li>Mozilla Firefox 88+</li>
                            <li>Safari 14+</li>
                            <li>Microsoft Edge 90+</li>
                        </ul>
                    `;
                }
            }
        });

        // 全局错误处理
        window.addEventListener('error', (event) => {
            console.error('全局错误:', event.error);
        });

        window.addEventListener('unhandledrejection', (event) => {
            console.error('未处理的Promise拒绝:', event.reason);
        });
    